<template>
  <v-app id="inspire">
    <nav class="navbar navbar-expand-lg fixed-top navbar-dark" style="background:rgba(24,25,33,255);box-shadow: 0px 5px 5px 1px rgba(0,0,0,0.6)">
      <a class="navbar-brand" href="/" style="font-size: 20px;">KharaMe</a>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav mr-auto">
          <li class="nav-item">
            <a class="nav-link" href="/">Home</a>
          </li>
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              Devices
            </a>
            <div class="dropdown-menu" style="background:rgba(34,35,43,255);box-shadow: 0px 5px 5px 1px rgba(0,0,0,0.6)" aria-labelledby="navbarDropdown">
              <a class="dropdown-item" href="/RMX1971">Realme 5 Pro</a>
              <a class="dropdown-item" href="/r5x">Realme 5 Series</a>
              <a class="dropdown-item" href="/EVEN">Realme C25 Series</a>
            </div>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="/blog">Guides</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="/about">About US</a>
          </li>
          <li class="nav-item dropdown" v-if="loggedin">
            <a class="nav-link dropdown-toggle" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              Admin Panel
            </a>
            <div class="dropdown-menu" style="background:rgba(34,35,43,255);box-shadow: 0px 5px 5px 1px rgba(0,0,0,0.6)" aria-labelledby="navbarDropdown">
              <h4 class="dropdown-item" style="cursor:default">Hi {{ username }}</h4>
              <a v-if="data['builds'] === 'Y'" class="dropdown-item" href="/admin/builds">Builds</a>
              <a v-if="data['builds'] === 'Y'" class="dropdown-item" href="/admin/screenshots">Screenshots</a>
              <a v-if="data['maintainers'] === 'Y'" class="dropdown-item" href="/admin/maintainers">Maintainers</a>
              <a v-if="data['blog'] === 'Y'" class="dropdown-item" href="/admin/blog">Guides</a>
              <a v-if="data['admin'] === 'Y'" class="dropdown-item" href="/admin/users">Users</a>
              <a class="dropdown-item" @click="logout()">Logout</a>
            </div>
          </li>
        </ul>
        <form class="form-inline my-2 my-lg-0">
          <v-autocomplete
          v-model="searched" :items="completedata" item-text="title"  item-value="url" cache-items class="mx-4"
          hide-no-data hide-details label="Search" solo-inverted @change="gotosearchedpage()"></v-autocomplete>
        </form>
      </div>
    </nav>

    <v-main>
      <router-view></router-view>
    </v-main>
    <v-footer padless style="background:rgba(28,29,38,255);box-shadow: 0px 5px 5px 1px rgba(0,0,0,0.6),0px -5px 5px 1px rgba(0,0,0,0.6);color:whitesmoke;">
      <v-col
        class="text-center"
        cols="12"
        style="margin-left:auto;margin-right:auto;margin-top:2.5%;"
      >
        <v-btn outlined rounded text dark class="foota" @click="rmx1971()"><i class="bi bi-telegram footicon"></i>&nbsp;&nbsp;Realme 5 Pro</v-btn>
        <v-btn outlined rounded text dark class="foota" @click="r5x()"><i class="bi bi-telegram footicon"></i>&nbsp;&nbsp;Realme 5 Series</v-btn>
        <v-btn outlined rounded text dark class="foota" @click="even()"><i class="bi bi-telegram footicon"></i>&nbsp;&nbsp;Realme C25 Series</v-btn>
        <v-btn outlined rounded text dark class="foota" @click="github()"><i class="bi bi-github footicon"></i>&nbsp;&nbsp;KharaMe-Devices</v-btn>
      </v-col>
      
      <v-row justify="center" style="margin-top:1%;margin-left:0.5%;margin-right:0.5%;line-height: 150%;">
        <v-col md="auto" style="margin-right:1%">
          <strong><div>Devices</div></strong>
          <div @click="redirect('/RMX1971')" class="footdiv">Realme 5 Pro</div>
          <div @click="redirect('/r5x')" class="footdiv">Realme 5 Series</div>
          <div @click="redirect('/EVEN')" class="footdiv">Realme C25 Series</div><br>
        </v-col>
        <v-col md="auto" style="margin-left:1%">
          <strong><div>Quick Links</div></strong>
          <div @click="redirect('/')" class="footdiv">Home</div>
          <div @click="redirect('/blog')" class="footdiv">Guides</div>
          <div @click="redirect('/about')" class="footdiv">About</div>
        </v-col>
        <v-col md="auto" style="margin-left:1%">
          <strong><a>Quick Links</a></strong><br>
          <div @click="redirect('/changes')" class="footdiv">Recent Changes</div>
          <div @click="redirect('/privacy')" class="footdiv">Privacy Policy</div>
        </v-col>
      </v-row>
      
      <v-col
        class="text-center"
        cols="12"
        style="margin:-1%"
      >
        <v-divider dark></v-divider>
      </v-col>      
      <v-col
        class="text-center"
        cols="12"
        style="margin-top:-1%"
      >
         {{ new Date().getFullYear() }}  - KharaMe 
        by MadhavSaladi(BabluS)
      </v-col>
  </v-footer>
  </v-app>
</template>
<script>
import axios from 'axios';

  export default {

    name: 'App',
    components: {

    },
    data: () => ({
      data: [],
      completedata: '',
      loggedin: false,
      username: '',
    }),

    created () {
      this.checkloggedin();
      this.getcompletedata();
    },

    methods: {
      // checkDarkModeStatus() {
      //   if (localStorage.getItem("dark") === 'yes') {
      //     this.$vuetify.theme.dark = true;
      //   } else {
      //     this.$vuetify.theme.dark = false;
      //   }
      // },
      checkloggedin() {
        this.current_time = Math.round(+new Date()/1000);
        if (sessionStorage.getItem("token") && sessionStorage.getItem("expire_time") > this.current_time) {
          this.loggedin= true;
          this.data = JSON.parse(sessionStorage.getItem('data'))
          this.username = this.data['username'];
        } else {
          sessionStorage.clear();
        }
      },
      getcompletedata() {
        let config = {
          method : 'get',
          url : `https://kharame-devices.herokuapp.com/getCompleteData`,
        };
        axios(config)
        .then((response) => {
          this.completedata = response.data.message;
        })
      },
      logout() {
        sessionStorage.clear();
        if (this.$route.path.slice(1,6) == 'admin') {
          window.location.href = '/'
        } else {
          this.$router.go('/')
        }
      },
      gotosearchedpage() {
        if (this.searched){
          window.location.href = '/'+this.searched
        }
      },
      redirect(url){
        window.location.href = url
      },
      rmx1971() {
          window.open("https://t.me/Realme5Pro_Global");
      },
      r5x() {
          window.open("https://t.me/Realme5Dev")
      },
      even() {
          window.open("https://t.me/even_discussion")
      },
      github() {
          window.open("https://github.com/KharaMe-devices")
      },
    },
  }
</script>
<style>
#inspire {
  color: whitesmoke;
  background:rgba(23,25,33,255);
  font-family: 'Montserrat', sans-serif;
}
.navbar {
  color: whitesmoke;
  font-size: 16px;
}
.navbar-nav .nav-item .nav-link:hover, .navbar .navbar-brand:hover {
    color: #1976d2;
}
.navbar-nav .nav-item .nav-link, .navbar .navbar-brand {
    color: whitesmoke;
}
.navbar-nav .nav-item .dropdown-item {
    color: whitesmoke;
}
.navbar-nav .nav-item .dropdown-item:hover {
    background: none;
    color: #1976d2;
}
.v-input__slot {
  background: rgba(63,67,83,255) !important;
}
.v-input__control .v-select__slot .v-label {
  color: whitesmoke;
}
/* .v-list-item__subtitle {
    line-break: anywhere;
} */
.v-input__control .v-select__slot .v-input__append-inner .v-input__icon .v-icon::before {
  color: whitesmoke;
}
.v-autocomplete__content {
  width: 10%;
}
.v-menu__content .v-list {
  background: rgba(34,35,43,255) !important;
  box-shadow: 0px 5px 5px 1px rgba(0,0,0,0.6);
}
.v-list-item__content .v-list-item__title {
  overflow: visible;
  white-space: inherit;
  color: whitesmoke;
}
.v-list-item__content .v-list-item__title:hover {
  color: #1976d2;
}
.foota {
  margin-left : 2%;
  margin-right: 2%;
  text-decoration:none;
}
.foota1 {
  margin-left : 2%;
  margin-right: 2%;
  font-size:16px;
  text-decoration:none;
  color: white !important;
}
.footicon {
  font-size: 16px;
}
.foota:hover {
  text-decoration: none;
}
.footdiv {
  text-decoration:none;
  color:whitesmoke;
  cursor:pointer;
  margin-bottom: 5%;
}
@media (max-width: 1000px) {
  .foota {
    margin: 2%
  }
  .footdiv {
    margin-bottom: 9%;
  }
  .v-menu__content {
    height: 200px;
  }
}
</style>